export const StockManagementStorageKey = 'stock-management';
